import Blue from "~/core";

new Blue({
	name: 'catalog',
	selector: ".catalog",
	setup(catalog) {

		const selectCategory = document.querySelector('#categoryFilter');
		const selectService = document.querySelector('#serviceFilter');
		const selectSearch = document.querySelector('#searchbox');


		if (selectCategory) {
			selectCategory.onchange = (e) => {

				const [option] = e.target.selectedOptions

				//get all test items on page.
				var catalogItems = document.querySelectorAll('.catalogitem');

				catalogItems.forEach((item) => {

					var categoryList = item.getAttribute('data-categorytype').split(',');



					if (categoryList.includes(option.value) || option.value == 'All') {


						item.classList.remove("hidden");
					}
					else {

						item.classList.add("hidden");
					}

				});

			}
		};

		if (selectService) {
			selectService.onchange = (e) => {

				const [option] = e.target.selectedOptions


				var catalogItems = document.querySelectorAll('.catalogitem');

				catalogItems.forEach((item) => {
					var serviceList = item.getAttribute('data-servicetype').split(',');

					if (serviceList.includes(option.value) || option.value == 'All') {
						item.classList.remove("hidden");
					}
					else {
						item.classList.add("hidden");
					}
				});

			}
		};

		if (selectSearch) {
			selectSearch.oninput = (e) => {
				//get all catalog items on page.
				var catalogItems = document.querySelectorAll('.catalogitem')
				// Locate the search input
				let search_query = document.getElementById("searchbox").value;
				// Loop through the catalog items
				for (var i = 0; i < catalogItems.length; i++) {
					// If the text is within the catalog...  
					if (catalogItems[i].innerText.toLowerCase()
						// ...and the text matches the search query...
						.includes(search_query.toLowerCase())) {
						// ...remove the `.hidden` class.
						catalogItems[i].classList.remove("hidden");
					} else {
						// Otherwise, add the class.
						catalogItems[i].classList.add("hidden");
					}
				}
			}
		}
	}
});